import { Theme } from "@mui/material/styles";

import { zeffyTheme } from "@/common/theme/theme";
import { zeffyOptionGroupLabelClasses } from "@/dashboard-design-system/OptionGroupLabel";

// Static, matching how real inputs pin their ::placeholder (BaseInput/styleHelpers.ts)
export const newsletterSelectPlaceholderSx = {
  color: zeffyTheme.palette.text.form.supershy,
} as const;

// One size for every label on the form, off the type scale, where the components ship a body2 input
// label and a quieter caption group label. Doubled up to outrank both of their own rules.
const labelTypography = {
  fontSize: "12.596px",
  fontWeight: 600,
  lineHeight: "17.994px",
  letterSpacing: "0.135px",
} as const;

export const newsletterFieldLabelsSx = (theme: Theme) => ({
  "&& [data-test='input-label-label-typography']": labelTypography,
  [`&& .${zeffyOptionGroupLabelClasses.labelForm}, && .${zeffyOptionGroupLabelClasses.labelNeutral}`]: labelTypography,
  // Repeats how DashboardInputLabel picks its colour, so both kinds of label land on the same one
  [`&& .${zeffyOptionGroupLabelClasses.labelNeutral}`]: { color: theme.palette.text.neutral.moderate },
  [`&& .${zeffyOptionGroupLabelClasses.labelForm}`]: { color: theme.palette.text.form.moderate },
});

// Theme-relative, matching the token DashboardAutocomplete paints its chevron with. Nested like
// DashboardSelect's own chevron rule, which a flatter selector loses to on specificity.
export const newsletterSelectIconSx = (theme: Theme) => ({
  "&&.MuiInputBase-root": {
    "&& .MuiSelect-icon": {
      color: theme.palette.text.form.quiet,
      fill: theme.palette.text.form.quiet,
    },
  },
});
